export const ORGANIZATION_ISSUE_TYPES_LIMIT = 25
export const ORGANIZATION_ISSUE_FIELDS_LIMIT = 50
export const ISSUE_TYPE_NAME_LIMIT = 64
export const ISSUE_TYPE_DESCRIPTION_LIMIT = 256
export const RESERVED_NAMES = ['issue', 'pr', 'pull-request', 'pull request']
export const MAX_PINNED_FIELDS = 10
